import axios from 'axios';

import { Faculty, FacultyRequest } from '@/module/Faculty/model/FacultyTypes';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Faculty>>('/faculties/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Faculty>(`/faculties/${id}`).then(getData);
}

export function getFaculties() {
  return axios.get<Faculty[]>('/faculties').then(getData);
}

export function getAccessibleFaculties() {
  return axios.get<Faculty[]>('/faculties/accessible').then(getData);
}

export function getFacultiesAsHeadOf() {
  return axios.get<Faculty[]>('/faculties/where-head-of').then(getData);
}

export function create(request: FacultyRequest) {
  return axios.post<Faculty>(`/faculties`, request).then(getData);
}

export function edit(id: Id, request: FacultyRequest) {
  return axios.put<Faculty>(`/faculties/${id}`, request).then(getData);
}
